<script>
import { getLeaderships } from '../api/lobbying';

export default {
  name: 'CpLeadership',
  components: {
    CpButton: require('../button').default,
    CpButtonLink: require('../button-link').default,
    CpImagesCarousel: require('../components/ImagesCarousel').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginBottom: require('../directives/margins').marginBottom,
  },
  data() {
    return {
      totalPages: 0,
      currentPage: 0,
      resizeObserver: null,
      isScrollingProgrammatically: false,
      loading: false,
      lawmakers: [],
      officeName: {
        0: 'The President',
        1: 'Speaker of the House',
        2: 'Senate Majority Leader',
        3: 'Senate Minority Leader',
        4: 'House Minority Leader',
      },
    };
  },
  mounted() {
    this.fetchLeaderships();
  },
  methods: {
    async fetchLeaderships() {
      this.loading = true;
      try {
        const response = await getLeaderships();
        this.lawmakers = response.leaderships.map((item, index) => {
          return {
            ...item,
            officeName: this.officeName[index],
          };
        });
      } catch (error) {
        console.error('Error fetching leaderships:', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div v-if="lawmakers.length" class="leadership-container">
    <h3 class="subheadline1 black-color">Leadership</h3>
    <CpImagesCarousel :carouselItems="lawmakers" />
  </div>
</template>

<style scoped>
.leadership-container {
  border: 1px solid var(--neutral3);
  border-radius: 8px;
  padding: 16px;
  background-color: var(--white);
}
</style>
